import React from 'react'
import cx from 'classnames'
import Skeleton from 'react-loading-skeleton'

export const VegaIconLoading = ({ className, size = 16 }) => {
	return (
		<div style={{ lineHeight: 1 }} className={cx(className)}>
			<Skeleton circle={true} height={size} width={size} />
		</div>
	)
}
